// extracted by mini-css-extract-plugin
module.exports = {"salary-calculator":"salaryCalculator_salary-calculator__fN1LB"};